import {UI} from "../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../PanelPage";
import {iFrameState} from "../../../services/IFrameState";
import {PoweredByBlink} from "../../PoweredByBlink";
import {isSmallScreen} from "../../../Utils";
import {GATE_TYPE} from "../../../../blink-sdk/Constants";
import {styleRule, styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {PanelLoginFooterBuilder, PromptInlineUserDashboard} from "../../panel-elements/LoginFooter";
import {PanelText} from "../../panel-elements/PanelText.jsx";
import {PanelActionButtonBuilder} from "../../panel-elements/ActionButton";
import {SubscribeFlowController} from "../../flows/SubscribeFlowController";
import {DonateFlowController} from "../../flows/DonateFlowController";
import {PurchaseFlowController} from "../../flows/PurchaseFlowController";
import {CloseController, LinkController} from "../../flows/BasicFlowControllers";
import {IdentityFlowController} from "../../flows/IdentityFlowController";
import {StyleElement} from "../../../../stem-core/src/ui/StyleElement";
import {NewsletterFlowController} from "../../flows/NewsletterFlowController";
import {PanelCloseButton} from "../../PanelCloseButton";
import {PanelFrame} from "./PanelFrame";
import {MerchantLogo} from "../../../common/MerchantLogo";
import {GiftSubscriptionFlowController} from "../../flows/GiftSubscriptionFlowController";
import {convertToUI} from "../../../widget/ui/MessageElement";
import {PanelLink} from "../../panel-elements/PanelLink.jsx";
import {PanelImage} from "../../panel-elements/PanelImage.jsx";


class BasePanelStyle extends BasePanelPageStyle {
    @styleRule
    message = this.themeProps.PANEL_MESSAGE_STYLE;

    @styleRule
    paragraph = {};

    @styleRuleInherit
    button = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_REGULAR + "!important",
    };

    @styleRule
    logo = {
        padding: "0",
        transform: "translateY(-2px)",
        marginLeft: 2,
    };
}

export const panelClassMap = new Map([
    ...[
        "div", "span", "p", "i", "nav",
        "strong", "em", "br", "b", "hr",
        "ul", "ol", "li", "code", "var",
        "h1", "h2", "h3", "h4", "h5", "h6",
        "parsererror", // This is to nicely display errors generated by DOMParser.parseFromString.
    ].map(tag => ([tag, UI.Primitive(tag)])),
    ["If", UI.Primitive("div")],
    ["Style", StyleElement],
    ["PanelLink", PanelLink], // Duplicate because of our current rendering engine (the DOM)
    ["Link", PanelLink],
    ["PanelImage", PanelImage],
    ["Text", PanelText],
    ["Logo", MerchantLogo],
    ["PanelFrame", PanelFrame],
    ["Close", PanelCloseButton],
    ["SubscribeButton", PanelActionButtonBuilder(SubscribeFlowController)],
    ["DonateButton", PanelActionButtonBuilder(DonateFlowController)],
    ["GiftSubscriptionButton", PanelActionButtonBuilder(GiftSubscriptionFlowController)],
    ["NewsletterButton", PanelActionButtonBuilder(NewsletterFlowController)],
    ["PurchaseButton", PanelActionButtonBuilder(PurchaseFlowController)],
    ["LinkButton", PanelActionButtonBuilder(LinkController)],
    ["CloseButton", PanelActionButtonBuilder(CloseController)],
    ["IdentityButton", PanelActionButtonBuilder(IdentityFlowController)],
    ["SubscribeLoginFooter", PanelLoginFooterBuilder(SubscribeFlowController)],
    ["DonateLoginFooter", PanelLoginFooterBuilder(DonateFlowController)],
    ["PurchaseLoginFooter", PanelLoginFooterBuilder(PurchaseFlowController)],
    ["PromptInlineUserDashboard", PromptInlineUserDashboard],
    ["PoweredByBlink", PoweredByBlink],
]);

@registerStyle(BasePanelStyle)
export class BasePanel extends BasePanelPage {
    widthValue = null;

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        if (isSmallScreen() && iFrameState.gateType === GATE_TYPE.popup) {
            attr.setStyle("width", this.getMaxWidth());
        }
        if (this.heightValue) {
            attr.setStyle("height", "");
        }
    }

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            withPanelFrame: false,
        };
    }

    render() {
        return convertToUI(iFrameState.panelContent, panelClassMap);
    }
}
